import { BASE_URL, DEPARTMENT } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICompanyInput } from "models/company";
import { IDepartments, IDepartmentsInput } from "models/departments";


export async function getDepartments(params: string = "") : Promise<IDepartments[]> {
  const response = await axios.get(BASE_URL + DEPARTMENT + params);
  return response.data;
}
export async function addDepartment(data: IDepartmentsInput) {
  const response = await axios.post(BASE_URL + DEPARTMENT, data);
  return response.data;
}
export async function editDepartment(data: IDepartmentsInput, id: string) {
  const response = await axios.patch(BASE_URL + DEPARTMENT + "/" + id, data);
  return response.data;
}

export async function deleteDepartment(id: string) {
  const response = await axios.delete(BASE_URL + DEPARTMENT + "/" + id);
  return response.data;
}

export const DepartmentsCells: HeadCell[] = [

  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "nameAr",
    numeric: false,
    disablePadding: false,
    label: "T_name_Ar",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
